export enum UserRoles {
    UNLOGGED = 'UNLOGGED',
    VISITOR = 'VISITOR',
    AGENT = 'AGENT',
    BUSINESS_ADMIN = 'BUSINESS_ADMIN',
    ADMIN = 'ADMIN',
    DPI = 'DPI',
}
